













































































import BaseText from '@/components/_base/BaseText.vue'
import BaseLink from '@/components/_base/BaseLink.vue'
import SiteSection from '@/components/SiteSection.vue'
import SiteHeading from '@/components/SiteHeading.vue'
import { gsap } from 'gsap'
import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
} from '@vue/composition-api'

export default defineComponent({
  name: 'SiteSectionTheParty',

  components: {
    SiteSection,
    SiteHeading,
  },

  setup() {
    const directionsUrl =
      'https://www.google.com/maps/place/Florida+Eventos/@20.714557,-103.4642052,17z/data=!3m1!4b1!4m6!3m5!1s0x8428a8d232ed63bd:0x4a19ef475f977005!8m2!3d20.714557!4d-103.4616303!16s%2Fg%2F1tdzx0nx?entry=ttu'
    const titleOne = ref<InstanceType<typeof BaseText> | null>(null)
    const titleTwo = ref<InstanceType<typeof BaseText> | null>(null)
    const titleThree = ref<InstanceType<typeof BaseText> | null>(null)
    const cta = ref<InstanceType<typeof BaseLink> | null>(null)

    const tl = gsap.timeline({
      paused: true,
      delay: 1,
    })

    onMounted(() => {
      const titleOneEl = titleOne.value?.$el
      const titleTwoEl = titleTwo.value?.$el
      const titleThreeEl = titleThree.value?.$el
      const ctaEl = cta.value?.$el

      if (!titleOneEl || !titleTwoEl || !titleThreeEl || !ctaEl) return

      const elements = [titleOneEl, titleTwoEl, titleThreeEl, ctaEl]

      tl.fromTo(
        elements,
        {
          y: 100,
          rotationX: -90,
        },
        {
          ease: 'expo.out',
          y: 0,
          rotationX: 0,
          duration: 1.5,
          stagger: 0.2,
        }
      )
    })

    onUnmounted(() => {
      tl.clear()
    })

    function visibilityChanged(isVisible: boolean) {
      if (!isVisible) return
      tl.play()
    }

    return {
      directionsUrl,
      titleOne,
      titleTwo,
      titleThree,
      cta,
      visibilityChanged,
    }
  },
})
